import { auditListRequest, auditListResponse } from '../../../../../backend/features/types/shared/auditList';
export const groupAuditListDef = {
    name: 'groupAuditList',
    requestSchema: auditListRequest,
    responseSchema: auditListResponse,
};
